import { FaUsers, FaLightbulb, FaRocket, FaHandsHelping } from "react-icons/fa";

export const reasons = [
  {
    name: "Networking Opportunities",
    description:
      "Connect with like-minded developers, tech leaders, and innovators from across the globe. Build lasting professional relationships.",
    icon: FaUsers,
  },
  {
    name: "Innovative Ideas",
    description:
      "Discover cutting-edge technologies, methodologies, and trends shaping the future of web development and coding.",
    icon: FaLightbulb,
  },
  {
    name: "Empower Your Career",
    description:
      "Boost your career by learning from industry experts, participating in workshops, and showcasing your skills.",
    icon: FaRocket,
  },
  {
    name: "Collaborative Spirit",
    description:
      "Join a community that values collaboration, mentorship, and sharing knowledge to raise the bar for everyone.",
    icon: FaHandsHelping,
  },
];
export const speakers = [
  {
    name: "Rafal Bobko",
    about: "JS & React Front Developer",
    img: "/images/photo.jpg",
  },
  {
    name: "Bob Rafalsky",
    about: "CEO CodersBros",
    img: "/images/bw.jpg",
  },
  {
    name: "Stacy Ztacy",
    about: "First Dog developer",
    img: "/images/stacy.jpg",
  },
  {
    name: "@MrX",
    about: "Real Satoshi Nakamoto",
    img: "/images/chair.jpg",
  },
];
